import illus1 from '../../assets/images/login/illus-1.svg'
import illus2 from '../../assets/images/login/illus-2.svg'
import illus3 from '../../assets/images/login/illus-3.svg'
import { LangManageEmployeePerformance, LangManageEmployeePerformanceDesc, LangPerformanceStatistics, LangPerformanceStatisticsDesc, LangWorkReports, LangWorkReportsDesc } from '../../constant/AuthConstant'

const data = [
  {
    illus: illus1,
    title: {
      ID: LangManageEmployeePerformance('ID'),
      EN: LangManageEmployeePerformance('EN')
    },
    desc: {
      ID: LangManageEmployeePerformanceDesc('ID'),
      EN: LangManageEmployeePerformanceDesc('EN')
    }
  },
  {
    illus: illus2,
    title: {
      ID: LangWorkReports('ID'),
      EN: LangWorkReports('EN'),
    },
    desc: {
      ID: LangWorkReportsDesc('ID'),
      EN: LangWorkReportsDesc('EN')
    }
  },
  {
    illus: illus3,
    title: {
      ID: LangPerformanceStatistics('ID'),
      EN: LangPerformanceStatistics('EN')
    },
    desc: {
      ID: LangPerformanceStatisticsDesc('ID'),
      EN: LangPerformanceStatisticsDesc('EN')
    }
  }
]

export default data
